import { ArrowUp } from "lucide-react";
import { WEDDING } from "@/lib/constants";

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-w-charcoal text-white section-padding" data-testid="footer">
      <div className="max-w-4xl mx-auto text-center">
        <div className="w-12 h-px bg-w-gold mx-auto mb-8" />

        <h2 className="font-heading text-3xl md:text-4xl font-light">
          {WEDDING.sposa} <span className="font-accent italic text-w-gold">&</span> {WEDDING.sposo}
        </h2>

        <p className="font-body text-sm text-white/50 mt-3 tracking-wider">
          {WEDDING.data} &middot; Borgio Verezzi &middot; La Fortezza
        </p>

        <button
          onClick={scrollToTop}
          data-testid="scroll-to-top"
          className="mt-10 mx-auto w-10 h-10 border border-white/20 flex items-center justify-center hover:border-w-gold hover:text-w-gold transition-colors duration-300"
        >
          <ArrowUp className="w-4 h-4" />
        </button>

        <p className="font-body text-[10px] text-white/20 mt-8 uppercase tracking-widest">
          Con amore, {WEDDING.nicknames}
        </p>
      </div>
    </footer>
  );
}
